import { CalendarClock, Lock, RefreshCw } from "lucide-react";
import {
  formatFrequencyHours,
  formatUpdateTill,
} from "../../lib/utils/reportUpdateConfig";
import styles from "./styles.module.scss";

interface ReportUpdateConfigReadonlyProps {
  updateTillDate: string;
  updateForIntervalHourFrequency: number;
  className?: string;
}

export function ReportUpdateConfigReadonly({
  updateTillDate,
  updateForIntervalHourFrequency,
  className,
}: ReportUpdateConfigReadonlyProps) {
  return (
    <div
      className={`${styles.scheduleBanner}${className ? ` ${className}` : ""}`}
    >
      <span className={styles.scheduleLabel}>
        <Lock size={11} />
        Update schedule
      </span>
      <span className={styles.scheduleItem}>
        <CalendarClock size={14} className={styles.scheduleIcon} />
        <span>
          Update till{" "}
          <span className={styles.scheduleValue}>
            {formatUpdateTill(updateTillDate)}
          </span>
        </span>
      </span>
      <span className={styles.scheduleDivider} aria-hidden />
      <span className={styles.scheduleItem}>
        <RefreshCw size={14} className={styles.scheduleIcon} />
        <span className={styles.scheduleValue}>
          {formatFrequencyHours(updateForIntervalHourFrequency)}
        </span>
      </span>
    </div>
  );
}
